import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { ReactComponent as ImageIcon } from "../../../../icons/image.svg";
import ConfirmModal from "../../ConfirmModal";
import "./style.scss";

interface Props {
  display: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}

const EmptyEditablePictureModal: FunctionComponent<Props> = ({ display, onConfirm, onDismiss }) => {
  const intl = useIntl();

  return (
    <ConfirmModal
      display={display}
      onConfirm={onConfirm}
      onDismiss={onDismiss}
      dismissLabel={intl.formatMessage({
        id: "kustom_NoCroppedPictureModal_letsCheck",
      })}
      confirmLabel={intl.formatMessage({
        id: "kustom_NoCroppedPictureModal_finished",
      })}
    >
      <div className="EmptyEditablePictureModal">
        <div className="EmptyEditablePictureModal-image">
          <ImageIcon />
        </div>
        <div className="EmptyEditablePictureModal-content">
          <p>
            {intl.formatMessage({
              id: "kustom_EmptyEditablePictureModal_areYouSure",
            })}
          </p>
        </div>
      </div>
    </ConfirmModal>
  );
};

export default EmptyEditablePictureModal;
